import { Injectable } from "@angular/core";
import { DateToString } from "src/app/core/pipe/pipe-date";
import { GeneralService } from "./general.service";
import { deepCopy } from "@angular-devkit/core/src/utils/object";

@Injectable({
    providedIn: 'root'
})
export class ConditionsService {

    dateOptions = {
        day: '2-digit',
        month: 'short',
        year: '2-digit'
    };

    public conditionsColMax = 0;

    constructor(
        protected gs: GeneralService
    ) {

    }


    calculate(amountCalc, conditions, conditionSelected = 'all', selectedUnit: any = {}) {

        let dateToString = new DateToString();

        return conditions.map(item => {

            if (item?.validUntil) {
                item.validUntilStr = dateToString.transform(item.validUntil, this.dateOptions);
            }

            item.conditionFixed = 0;
            item.amountReduce = 0;
            item.amountReducePercentage = 0;
            item.condition = this.getConditionList(item.condition);

            let balancePercentage = 0;
            let amountTotal = 0;
            let amount = amountCalc;

            item.condition = item.condition.map(cond => {

                if (cond.attr.quantity && !cond.quantity && cond.tag_id != '136')
                    return;

                cond.percentage = this.gs.convertMoneyToDouble(cond.percentage);
                cond.amount = this.gs.convertMoneyToDouble(cond.amount);

                if (cond.tag_id == '136' && balancePercentage) {

                    if (!cond.percentage)
                        cond.percentage = 0;

                    cond.percentage -= balancePercentage;
                }

                if (!cond.fixed) {
                    cond.amountTotal = amount * (cond.percentage / 100) * (cond?.attr?.operation || 1);
                    cond.amountDiv = cond.amountTotal / (cond.quantity || 1);
                } else {
                    cond.amountTotal = cond.amount * (cond.quantity || 1) * (cond?.attr?.operation || 1);
                    cond.amountDiv = cond.amount;
                    cond.percentage = (cond.amountTotal * 100 / amount) * (cond?.attr?.operation || 1);
                    if (cond?.attr?.operation != -1)
                        balancePercentage += cond.percentage;
                    else
                        cond.amount = cond.amount * -1
                }


                amountTotal += cond.amountTotal;

                cond.percentage = this.gs.convertMoneyToDouble(cond.percentage);

                if (cond.amountTotal < 0) {
                    item.amountReduce += cond.amountTotal;
                    amount += cond.amountTotal;
                }

                return cond;

            }).filter(item => !isNaN(item?.amountTotal)).sort((a, b) => a?.attr?.sort - b?.attr?.sort);

            if (item.condition.length + (item.amountReduce < 0 ? 1 : 0) > this.conditionsColMax)
                this.conditionsColMax = item.condition.length + (item.amountReduce < 0 ? 1 : 0);

            item.amountCalc = amountCalc - item.conditionFixed;
            item.amountTotal = item.amountCalc + item.amountReduce;


            return item;

        }).filter(item => {
            return (!item?.validUntil || new Date(item.validUntil) >= new Date())
                && (!selectedUnit
                    || conditionSelected == 'all'
                    || !item?.restricted
                    || (item?.applyBlocks && selectedUnit?.blockId && item.applyBlocks.indexOf(selectedUnit.blockId) > -1)
                    || (item?.applyUnitTypes && selectedUnit?.blockTypeId && item.applyUnitTypes.indexOf(selectedUnit.blockTypeId) > -1)
                    || (item?.applyUnits && selectedUnit?.id && item.applyUnits.indexOf(selectedUnit.id) > -1)
                )
                ;
        }).filter(Boolean);

        return conditions;
    }


    getConditionList(data) {

        let nData = [];

        for (const field in data) {
            let part = field.split('_');
            let nf = {};
            nf[part[0]] = data[field];

            nData[part[1]] = typeof nData[part[1]] == 'undefined' ? { ...nf, ...this.gs.getTags('conditionType', false, part[1]) }
                : { ...nData[part[1]], ...nf };
        }
        nData = nData.filter(item => item?.active).filter(Boolean).sort((a, b) => a?.attr?.priority - b?.attr?.priority);

        return nData;
    }

}